// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { expandPlugin } from '@atlaskit/editor-plugin-expand';
export type {
	ExpandPlugin,
	ExpandPluginState,
	ExpandPluginOptions,
	InsertMethod,
	ExpandPluginDependencies,
} from '@atlaskit/editor-plugin-expand';
